import React, { useContext, useEffect, useState } from 'react';
import { CodeContext } from '../context/CodeContext';
import { conf } from '../config';
import './DayModal.css';


const TOGGLE_CONFIG = {
  10:  { ext: 'jpg', mode: 'replace' },
  14:  { ext: 'jpg', mode: 'replace' },
  28: { ext: 'png', mode: 'overlay', animation: 'slide' },
  31: { ext: 'png', mode: 'overlay', animation: 'slide' },
};

function DayModal({ open, handleClose, dayData }) {
  const [selectedVote, setSelectedVote] = useState(dayData.vote || '');
  const [displayPath, setDisplayPath]   = useState(dayData.image_path);
  const [overlayVisible, setOverlayVisible] = useState(false);
  const [overlayPath, setOverlayPath]   = useState('');
  const [overlayAnim, setOverlayAnim]   = useState('fade'); // « fade » par défaut

  const { code } = useContext(CodeContext);

  // ⇨ remise à zéro quand on change de jour
  useEffect(() => {
    setSelectedVote(dayData.vote || '');
    setDisplayPath(dayData.image_path);
    setOverlayVisible(false);
    setOverlayPath('');
  }, [dayData]);

  if (!open) return null;

  const config = TOGGLE_CONFIG[dayData.day];

  /* ------------------------------------------------------------------ */
  /*  BASCULE IMAGE / OVERLAY                                            */
  /* ------------------------------------------------------------------ */
  const toggleImage = (e) => {
    e.stopPropagation();
    if (!config) return;

    // chemin alternatif  *_bis.ext
    const altRel = dayData.image_path.replace(/\.(jpg|jpeg|png)$/i, `_bis.${config.ext}`);
    const host   = conf.node_env === 'production' ? '' : 'http://localhost:5000';
    const altAbs = `${host}${altRel}`;

    if (config.mode === 'replace') {
      setDisplayPath((prev) => (prev === dayData.image_path ? altRel : dayData.image_path));
    } else if (config.mode === 'overlay') {
      if (!overlayVisible) { // ouverture
        setOverlayPath(altAbs);
        setOverlayAnim(config.animation || 'fade');
        setOverlayVisible(true);
      } else {              // fermeture
        setOverlayVisible(false);
      }
    }
  };

  const absoluteDisplayPath =
    `${conf.node_env === 'production' ? '' : 'http://localhost:5000'}${displayPath}`;

  /* ------------------------------------------------------------------ */
  /*  ENREGISTREMENT DU VOTE                                             */
  /* ------------------------------------------------------------------ */
  const handleVoteChange = (e) => {
    const vote = e.target.value;
    setSelectedVote(vote);

    fetch(
      `${conf.node_env === 'production' ? '' : 'http://localhost:5000'}/api/day/${dayData.day}/vote`,
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ vote }),
      }
    ).catch((error) => console.error('Error saving vote:', error));
  };

  /* ------------------------------------------------------------------ */
  /*  RENDU                                                              */
  /* ------------------------------------------------------------------ */
  return (
    <>
      {/* ------------------- OVERLAY PLEIN ÉCRAN ---------------------- */}
      {overlayVisible && (
        <div
          className={`fullscreen-overlay ${overlayAnim}`} // fade | slide | none
          onClick={toggleImage}
        >
          <img src={overlayPath} alt="" className="fullscreen-img" />
        </div>
      )}

      {/* ----------------------- MODAL PRINCIPAL ---------------------- */}
      <div className="modal-overlay" onClick={handleClose}>
        <div className="modal-content" onClick={(e) => e.stopPropagation()}>
          <img
            src={absoluteDisplayPath}
            alt={`Jour ${dayData.day}`}
            className={`modal-image ${config ? 'clickable' : ''}`}
            onClick={toggleImage}
          />

          {/* ------------------ TEXTE & RÉCOMPENSE -------------------- */}
          <div className="modal-text">
            <h2>{dayData.text}</h2>

            {dayData.reward ? (
              <>
                <p>
                  Félicitations&nbsp;! Tu as gagné un bon pour le&nbsp;
                  <strong>Jour {dayData.day}</strong>&nbsp;!<br />
                  Récupère-le pour demander ton prix&nbsp;!
                </p>
                <div className="modal-bon">
                  <div className="modal-bon-text">
                    <h3>
                      <strong>Bon du Jour {dayData.day}</strong>
                    </h3>
                    <h4>{dayData.reward.item}</h4>
                  </div>
                  <p>Code&nbsp;: {code}</p>
                </div>
              </>
            ) : (
              <p>
                Pas de récompense pour le&nbsp;
                <strong>Jour {dayData.day}</strong>…
              </p>
            )}
          </div>

          {/* ------------------------- VOTE --------------------------- */}
          <div className="vote-section">
            <p>
              À quel point tu as <strong>chaud</strong>&nbsp;? Note cette image&nbsp;:
            </p>
            <form>
              {[
                ['cold', '🥶'],
                ['mid-cold', '😬'],
                ['neutral', '😐'],
                ['mid-hot', '😊'],
                ['hot', '🥵'],
              ].map(([value, emoji]) => (
                <div className="vote-option" key={value}>
                  <input
                    type="radio"
                    id={`vote-${value}`}
                    name="vote"
                    value={value}
                    checked={selectedVote === value}
                    onChange={handleVoteChange}
                  />
                  <label htmlFor={`vote-${value}`}>{emoji}</label>
                </div>
              ))}
            </form>
          </div>

          <button onClick={handleClose} className="close-button">
            Fermer
          </button>
        </div>
      </div>
    </>
  );
}

export default DayModal;